<template>
<div class="sticky-top shadow-sm">
  <div v-if="isTestEnv" class="bg-danger text-white text-center fw-bold small py-1">
    TEST ENVIRONMENT
  </div>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark px-2 mb-2">
    <div class="container-fluid">
      <!-- Brand -->
      <div class="navbar-brand d-flex flex-column lh-1 py-1">
        <span>{{ companyName }}</span>
        <span class="small">Admin Console
        <span class="text-secondary ms-2" style="font-size: .6em">
          V{{ buildTime }}
        </span>
        </span>
      </div>

      <template v-if="isLoggedIn()">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#adminNav"
          aria-controls="adminNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="adminNav">
          <!-- Main links -->
          <ul class="navbar-nav ms-lg-auto mb-2 mb-lg-0">
            <li class="nav-item"><router-link class="nav-link" to="/summaries">SUMMARIES</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/transactions">TRANSACTIONS</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/memotxns">REFUNDS/CHARGEBACKS</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/refundrequests">REFUND REQUESTS</router-link></li>

            <!-- Settings -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa fa-cogs"></i><span class="d-lg-none ms-2">Settings</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-lg-end py-0 dropdown-menu-dark">
                <li class="py-2 text-white fw-bold text-center">Settings</li>
                <li v-for="item in settingsItems" :key="item.to">
                  <router-link :to="item.to" class="dropdown-item">
                    {{ item.label }}
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- User -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa fa-user-circle"></i><span class="d-lg-none ms-2">{{ $store.state.token.userId }}</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-lg-end py-0 dropdown-menu-dark">
                <li class="py-2 text-white fw-bold text-center">{{ $store.state.token.userId }}</li>
                <li>
                  <router-link to="/pwchange" class="dropdown-item">
                    <i class="fa fa-lock me-2"></i>Change Password
                  </router-link>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="logout">
                    <i class="fa fa-power-off me-2"></i>Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </nav>
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'

export default {
  name: 'AdminHeader',
  mixins: [HelpersMixin],
  data () {
    return {
      companyName: '',
      buildTime: process.env.VUE_APP_BUILD_TIME,
      isTestEnv: false
    }
  },
  computed: {
    // Data-driven settings menu: permission-gated items are filtered in one place
    settingsItems () {
      const items = [
        { to: '/merchants', label: 'Merchants' },
        { to: '/tpattribs', label: 'Processors', perm: 'AX_PROC_MAINT' },
        { to: '/routingrules', label: 'Routing Rules', perm: 'AX_ROUTINGRULE_MAINT' },
        { to: '/referencedata', label: 'Reference Data', perm: 'AX_REFDATA_MAINT' },
        { to: '/adminusers', label: 'Admin Users', perm: 'AX_ADMINUSER_MAINT' },
        { to: '/cacherefresh', label: 'Cache Refresh' },
        { to: '/mercsettlementcalc', label: 'Merchant Settlement Calculator' },
        { to: '/mercsettlementreports', label: 'Merchant Settlement Reports' },
        { to: '/reservereleasecalc', label: 'Merchant Reserve Release Calculator' },
        { to: '/procsettlementcalc', label: 'Processor Settlement Calculator' },
        { to: '/procreservecalc', label: 'Processor Reserve Calculator' },
        { to: '/emailextract', label: 'Email Extract' }
      ]
      return items.filter(i => !i.perm || this.hasPermission(i.perm))
    }
  },
  mounted () {
    const host = window.location.hostname
    this.isTestEnv = ['localhost', 'test', 'dev'].some(s => host.includes(s))
    this.extractCompanyName()
    this.axios.get('/ax/sessionCheck')
      .then(r => console.log('Authenticated: ' + r.status + ' current route: ' + this.$route.path))
      .catch(e => console.log('ERROR on home: ' + (e.response && e.response.status)))
  },
  methods: {
    isLoggedIn () {
      return !!(this.$store.state.token && this.$store.state.token.tokenId)
    },
    logout () {
      const done = () => {
        this.$store.commit('clearToken')
        this.$router.push('/login')
      }
      this.axios.get('/ax/logout').then(done).catch(e => { console.log(e); done() })
    },
    extractCompanyName () {
      const sa = document.location.host.split('.')
      this.companyName = sa[Math.max(sa.length - 2, 0)].toUpperCase()
    }
  }
}
</script>

<style scoped>
.dropdown-item {
  font-size: .8em;
  border-top: 1px solid #d3d3d3;
  padding: .8em 1em;
}
.navbar-nav .nav-link {
  font-size: .75em;
}
/* Keep long dropdowns usable on short screens */
.dropdown-menu {
  max-height: 80vh;
  overflow-y: auto;
}
.navbar-nav .nav-link {
  font-size: .75em;
  letter-spacing: .04em;
  color: rgba(255, 255, 255, .7);
  border-bottom: 2px solid transparent;
}
.navbar-nav .nav-link:hover,
.navbar-nav .nav-link:focus {
  color: #fff;
}
.navbar-nav .nav-link.router-link-active {
  color: #fff;
  border-bottom-color: #0dcaf0; /* Bootstrap info color */
}
/* On mobile, use a left bar instead of an underline */
@media (max-width: 991.98px) {
  .navbar-nav .nav-link.router-link-active {
    border-bottom-color: transparent;
    border-left: 3px solid #0dcaf0;
    padding-left: .75rem;
  }
}
</style>
